import { IAppContext } from 'App/AppContext';
import { sortOnArray, sortOnString , sortOnCode } from 'utils/sorting';
import { IColumn } from '@fluentui/react';
import { Owner } from 'models/owner';
import ProcessingActivity from 'models/processingActivity';

export const getAscendingSortValueKey = (a: ProcessingActivity, b: ProcessingActivity, key: string, appContext: IAppContext): number => {
  if (key === 'code') return sortOnCode(a.code, b.code);
  if (key === 'name') return sortOnString(a.name, b.name);
  if (key === 'status') return a.state - b.state;
  if (key === 'role') return a.role - b.role;
  if (key === 'tags') return sortOnArray(a.tagIds, b.tagIds);
  if (key === 'owner') {
    return Owner.sort(a, b, appContext);
  }
  if (key === 'permissions') {
    const a1 = appContext.globalDataCache.authSchemas.get(a.authSchemaId);
    const b1 = appContext.globalDataCache.authSchemas.get(b.authSchemaId);

    return sortOnString(a1.name, b1.name);
  }

  return 1;
};

export const copyAndSortProcessingActivities = (
  items: ProcessingActivity[],
  column: IColumn,
  isSortedDescending: boolean | undefined,
  appContext: IAppContext,
): ProcessingActivity[] => {
  const key = column.key;

  return items.slice().sort((a: ProcessingActivity, b: ProcessingActivity) => {
    const tmp = getAscendingSortValueKey(a, b, key, appContext);

    return isSortedDescending ? -tmp : tmp;
  });
};
